import { useRoutes } from "react-router-dom";
import ErrorPage from "../pages/ErrorPage";
import Layout from "../themes";
import Order from "@/pages/Order";
import OrderByPOS from "@/pages/OrderByPOS";
import VerifyPage from "@/pages/VerifyPage";
import ProtectedRoute from "@/router/ProtectedRoute.tsx";
import Chef from "@/pages/Chef";
import LoadingPage from "@/components/Base/LoaingPage";
import { useVerifyToken } from "@/hooks/useVerifyToken";

function Router() {
    const { isVerifying } = useVerifyToken();

    const routes = [
        {
            path: "/",
            element: (
                <ProtectedRoute>
                    <Layout />
                </ProtectedRoute>
            ),
            children: [
                {
                    path: "/waiter-order",
                    element: <Order />,
                },
                {
                    path: "/",
                    element: <Chef />,
                },
                {
                    path: "/waiter-order/:id",
                    element: <OrderByPOS />,
                }
            ],
        },
        {
            path: "/login",
            element: <VerifyPage />,
        },
        {
            path: "/verify",
            element: <VerifyPage />,
        },
        {
            path: "/error-page",
            element: <ErrorPage />,
        },
        {
            path: "*",
            element: <ErrorPage />,
        },
    ];

    const routeElement = useRoutes(routes);

    return isVerifying ? <LoadingPage/> : routeElement;
}

export default Router;
